function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M6.498 30.928L5.071 1.664H4l1.07 29.264h1.428z"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M7.093 30.93L5.666 1.664 23.323.405l-.29 3.877L24.72 3.01l1.406 1.272V.204L28.982 0v32L7.093 30.93zM23.9 12.41l-4.596.114c.085-2.398-.942-2.626-1.513-2.626-.543 0-1.456.17-1.456 1.456 0 1.309 1.335 2.048 2.902 2.916 2.226 1.232 4.92 2.724 4.92 6.477 0 3.597-2.798 5.253-6.366 5.253-3.683 0-6.91-1.256-6.538-6.767h4.825c-.058 2.227.428 3.027 1.655 3.027.943 0 1.37-.543 1.37-1.456 0-1.383-1.39-2.199-2.99-3.137-2.167-1.271-4.718-2.767-4.718-6.2 0-3.425 2.256-5.71 6.281-5.71 4.026 0 6.338 2.2 6.224 6.653z",
  clipRule: "evenodd"
});

var SvgStorybook = function SvgStorybook(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#1B1F23",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32"
  }, props), _ref, _ref2);
};

export default __webpack_public_path__ + "9eb929c4a3b90a6a13356db1e4b745d5.svg";
export { SvgStorybook as ReactComponent };


//////////////////
// WEBPACK FOOTER
// ../icons/svg/storybook.svg
// module id = null
// module chunks = 